import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator, storeAreYouSureModalCallback, storeFastFirm } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomDatePicker from "../../../components/CustomDatePicker";
import { ServiceService } from "../../../services/ServiceService";
import CustomNumberInput from "../../../components/CustomNumberInput";
import moment from "moment";
import { CompanyService } from "../../../services/CompanyService";
import { AddAgreementRequest, AddAgreementRequestAgreementDetail } from "../../../models/request/agreement/AddAgreementRequest";
import { AgreementService } from "../../../services/AgreementService";
import { AddAgreementResponse } from "../../../models/response/agreement/AddAgreementResponse";
import { GetAgreementByIdResponse, GetAgreementByIdResponseAgreementDetail } from "../../../models/response/agreement/GetAgreementByIdResponse";
import { GetServiceByIdResponse, GetServiceByIdResponseServiceMultiplier } from "../../../models/response/service/GetServiceByIdResponse";
import AgreementDetails from "./Components/AgreementDetails";
import GeneralInformation from "./Components/GeneralInformation";
import PageHeader from "../../../components/PageHeader";

const AgreementAdd = () => {
    const navigate = useNavigate();
    const pageName = "Antrepo Modülü > Anlaşmalar > Anlaşma Kayıt"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const generalInformationRef: any = useRef();
    const agreementDetailsRef: any = useRef();

    const [agreementId, setAgreementId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [isOpenArea, setIsOpenArea] = useState(false);
    const [isClosedArea, setIsClosedArea] = useState(true);
    const [isHeatControllerRoom, setIsHeatControllerRoom] = useState(false);
    const [selectedHeatControlDetail, setSelectedHeatControlDetail] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);
    const [startDate, setStartDate] = useState<string | undefined>(moment(new Date()).format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState<string | undefined>(moment().endOf('year').format('YYYY-MM-DD'));
    const [selectedProductKind, setSelectedProductKind] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [selectedCompany, setSelectedCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isIncome, setIsIncome] = useState(true);
    const [isOutcome, setIsOutcome] = useState(false);

    const [agreementDetails, setAgreementDetails] = useState<GetAgreementByIdResponseAgreementDetail[]>([])

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getPrefixAgreementName = (_selectedCompany: CustomSingleSelectModel, _isOpenArea: boolean, _isClosedArea: boolean, _isHeatControllerRoom: boolean, _selectedHeatControlDetail: CustomSingleSelectModel, _selectedProductKind: CustomSingleSelectModel) => {
        return [
            _selectedCompany?.label,
            (_isOpenArea ? 'Açık Alan' : _isClosedArea ? 'Kapalı Alan' : _isHeatControllerRoom ? 'Isı Kontrollü Oda' : ''),
            _selectedHeatControlDetail?.label,
            _selectedProductKind?.label?.split('-')[0]?.trim(),
        ].filter(x => x && !Helpers.isEmpty(x)).join(' - ')
    }

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetAgreementByIdResponse = await AgreementService.getAgreementById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setAgreementId(response.data.agreementId);
                setRefNo(response.data.refNo);
                setName(response.data.name == getPrefixAgreementName(
                    { label: response.data.selectedCompanyName, value: response.data.selectedCompanyId },
                    response.data.isOpenArea, response.data.isClosedArea, response.data.isHeatControllerRoom,
                    { label: response.data.heatControlDetailName, value: response.data.heatControlDetailId },
                    { label: response.data.productKindName, value: response.data.productKindId }) ? '' : response.data.name);

                if (response.data.selectedCompanyId)
                    setSelectedCompany({ label: response.data.selectedCompanyName, value: response.data.selectedCompanyId });

                setIsOpenArea(response.data.isOpenArea);
                setIsClosedArea(response.data.isClosedArea);
                setIsHeatControllerRoom(response.data.isHeatControllerRoom);
                setIsCustomActive(response.data.isCustomActive);
                setStartDate(response.data.startDate);
                setEndDate(response.data.endDate);
                setIsIncome(response.data.isIncome);
                setIsOutcome(response.data.isOutcome);

                if (response.data.productKindId)
                    setSelectedProductKind({ label: response.data.productKindName, value: response.data.productKindId });

                if (response.data.heatControlDetailId)
                    setSelectedHeatControlDetail({ label: response.data.heatControlDetailName, value: response.data.heatControlDetailId });

                setAgreementDetails(response.data.agreementDetails);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const saveAgreement = async () => {
        try {
            /*if (Helpers.isEmpty(name))
                toast.error('Ad alanını doldurunuz!')
            else*/ if (!selectedCompany)
                toast.error('Müşteri alanını doldurunuz!')
            else if (Helpers.isEmpty(startDate))
                toast.error('Başlangıç Tarihi alanını doldurunuz!')
            else if (Helpers.isEmpty(endDate))
                toast.error('Bitiş Tarihi alanını doldurunuz!')
            else if (!selectedProductKind)
                toast.error('Ürün Cinsi alanını doldurunuz!')
            else if (!isOpenArea && !isClosedArea && !isHeatControllerRoom)
                toast.error('Açık Alan veya Kapalı Alan veya Isı Kontrollü Oda alanlarından en az bir tanesi dolu olmalıdır!')
            else if (isHeatControllerRoom && !selectedHeatControlDetail)
                toast.error('Derece alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var o: AddAgreementRequest = {
                    agreementId: agreementId,
                    endDate: endDate,
                    heatControlDetailId: selectedHeatControlDetail?.value,
                    isClosedArea: isClosedArea,
                    isCustomActive: isCustomActive,
                    isHeatControllerRoom: isHeatControllerRoom,
                    isIncome: isIncome,
                    isOpenArea: isOpenArea,
                    isOutcome: isOutcome,
                    name: !Helpers.isEmpty(name) ? name : [
                        selectedCompany?.label,
                        (isOpenArea ? 'Açık Alan' : isClosedArea ? 'Kapalı Alan' : isHeatControllerRoom ? 'Isı Kontrollü Oda' : ''),
                        selectedHeatControlDetail?.label,
                        selectedProductKind?.label?.split('-')[0]?.trim(),
                    ].filter(x => x && !Helpers.isEmpty(x)).join(' - '),
                    productKindId: selectedProductKind.value,
                    refNo: refNo,
                    selectedCompanyId: selectedCompany.value,
                    startDate: startDate,
                    agreementDetails: agreementDetails.map(function (x) {

                        var o: AddAgreementRequestAgreementDetail = {
                            agreementDetailId: x.agreementDetailId.startsWith('newrecrd') ? undefined : x.agreementDetailId,
                            currencyTypeId: x.currencyTypeId,
                            multiplier1Id: x.multiplier1Id,
                            multiplier2Id: x.multiplier2Id,
                            serviceId: x.serviceId,
                            unitPrice: x.unitPrice?.toString(),
                            minPrice: x.minPrice?.toString(),
                            potTypeId: x.potTypeId,
                        }

                        return o;
                    }),
                }

                var response: AddAgreementResponse = await AgreementService.addAgreement(o);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            { text: 'Anlaşma Detayları', ref: agreementDetailsRef },
                        ]}
                    />

                    <GeneralInformation
                        endDate={endDate}
                        generalInformationRef={generalInformationRef}
                        isClosedArea={isClosedArea}
                        isCustomActive={isCustomActive}
                        isHeatControllerRoom={isHeatControllerRoom}
                        isIncome={isIncome}
                        isOpenArea={isOpenArea}
                        isOutcome={isOutcome}
                        name={name}
                        refNo={refNo}
                        selectedCompany={selectedCompany}
                        selectedHeatControlDetail={selectedHeatControlDetail}
                        selectedProductKind={selectedProductKind}
                        setEndDate={setEndDate}
                        setIsClosedArea={setIsClosedArea}
                        setIsCustomActive={setIsCustomActive}
                        setIsHeatControllerRoom={setIsHeatControllerRoom}
                        setIsIncome={setIsIncome}
                        setIsOpenArea={setIsOpenArea}
                        setIsOutcome={setIsOutcome}
                        setName={setName}
                        setSelectedCompany={setSelectedCompany}
                        setSelectedHeatControlDetail={setSelectedHeatControlDetail}
                        setSelectedProductKind={setSelectedProductKind}
                        setStartDate={setStartDate}
                        startDate={startDate}
                    />

                    <AgreementDetails
                        agreementDetails={agreementDetails}
                        agreementDetailsRef={agreementDetailsRef}
                        isIncome={isIncome}
                        setAgreementDetails={setAgreementDetails}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={() => saveAgreement()}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default AgreementAdd;